import { InputText } from "primereact/inputtext";

const InputTextTemplate = (options) => {
    return (
        <InputText
            value={options.value}
            onChange={
                (e) => options.filterApplyCallback(e.target.value)
            }
        />
    );
}

export default InputTextTemplate;